import React, { useMemo } from "react";
import { StandSlide, HorizontalSlide } from "overlapping_slide";
import { useTranslation } from "react-i18next";

import ImgClickArt from "assets/images/Slider/click_art.png";
import ImgClickBbuzz from "assets/images/Slider/click_bbuzz.png";
import ImgClickYeol from "assets/images/Slider/click_yeol.png";
import ImgClickYeolEN from "assets/images/Slider/click_yeol_en.svg";
import ImgArt from "assets/images/Slider/artnguide.png";
import ImgBBuzz from "assets/images/Slider/bbuzzart.png";
import ImgYeolmae from "assets/images/Slider/yeolmae.png";
import ImgForcusArt from "assets/images/Slider/focus_art.png";
import ImgForcusBbuzz from "assets/images/Slider/focus_bbuzz.png";
import ImgForcusYeol from "assets/images/Slider/focus_yeol.png";
import SlideDown from "assets/images/Slider/down.png";

import * as S from "./style";
import useWindowSize, { Size } from "hooks/useWindowSize";

function Slider() {
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width < 1025;

  const { t, i18n } = useTranslation("common");

  const data = [
    {
      color:
        "linear-gradient(180deg, #F8F2FE 0%, rgba(248, 242, 254, 0) 100%), #FFFFFF",
      bgColor: "#F8F2FE",
      icon: ImgClickBbuzz,
      logo: ImgBBuzz,
      // title: "버즈아트",
      title: `${t("BBUZZ ART")}`,
      subtitle: `${t("At BBUZZART")}`,
      imgFocus: ImgForcusBbuzz,
      page: "BBUZZART",
      colorPage: "#E3CAFF",
      link: "https://www.bbuzzart.com",
    },
    {
      color:
        "linear-gradient(180deg, #FFF5E6 28.86%, rgba(255, 245, 230, 0) 100%), #FFFFFF",
      bgColor: "#FFF9EF",
      icon: ImgClickYeol,
      iconEN: ImgClickYeolEN,
      logo: ImgYeolmae,
      title: `${t("YEOLMAE ASSET")}`,
      subtitle: `${t("Yeolmae Asset offers")}`,
      imgFocus: ImgForcusYeol,
      page: "YEOLMAE ASSET",
      colorPage: "#FFE0B0",
      // link : ""
    },
    {
      color:
        "linear-gradient(180deg, #E9F9F1 0%, rgba(233, 249, 241, 0) 100%), #FFFFFF",
      bgColor: "#E9F9F1",
      icon: ImgClickArt,
      logo: ImgArt,
      title: `${t("ART n GUIDE")}`,
      subtitle: `${t("ArtnGuide provides")}`,
      imgFocus: ImgForcusArt,
      page: "ARTnGUIDE",
      colorPage: "#97DCC3",
      link: "https://artnguide.co.kr",
    },
  ];

  const slideData = data.map((dt) => {
    return {
      color: dt.color,
      child: (
        <div className="container">
          <div className="head-slider" style={{ background: dt.bgColor }}>
            <div className="item-head">
              <img src={dt.imgFocus} alt="icon" />
              <div style={{ color: dt.colorPage }}>{dt.page}</div>
            </div>
          </div>
          <img
            className="click"
            src={dt.iconEN && i18n.language === "en" ? dt.iconEN : dt.icon}
            alt="click"
            onClick={() => {
              if (dt.link) {
                window.open(dt.link, "_blank");
              }
            }}
          />
          <div className="wp-logo">
            <img src={dt.logo} alt="ImgArt" />
          </div>
          <div className="content">
            <div className="title">{dt.title}</div>
            <div className="subtitle">{dt.subtitle}</div>
          </div>
        </div>
      ),
    };
  });

  const slideDataMobile = data.map((dt) => {
    return {
      color: dt.color,
      child: (
        <div className="container-mobile">
          <div className="head-slider" style={{ background: dt.bgColor }}>
            <div className="item-head">
              <img src={dt.imgFocus} alt="icon" />
              <div style={{ color: dt.colorPage }}>{dt.page}</div>
            </div>
          </div>
          <img
            className="click"
            src={dt.iconEN && i18n.language === "en" ? dt.iconEN : dt.icon}
            alt="click"
            onClick={() => {
              if (dt.link) {
                window.open(dt.link, "_blank");
              }
            }}
          />
          <div className="wp-logo">
            <img src={dt.logo} alt="ImgArt" className="logo" />
          </div>
          <div className="content">
            <div className="title">{dt.title}</div>
            <div className="subtitle">{dt.subtitle}</div>
          </div>
        </div>
      ),
    };
  });

  const ScrollToCenter = (e: any) => {
    // const startScrollOffset = window.pageYOffset;
    // console.log("tu=>", startScrollOffset);
    e.preventDefault();
    const element = document.getElementById("about");
    const rect = element?.getBoundingClientRect();
    const x = rect?.top;
    const scrollTop = document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    if (x) {
      window.scroll({
        top: scrollTop + x + 20,
        behavior: "smooth",
      });
    }
  };

  const renderSlider = useMemo(() => {
    if (isMobile) {
      return (
        <S.ContainerMobile>
          <StandSlide
            slideData={slideDataMobile}
            isAutoNext={true}
            timeNext={4000}
          />
        </S.ContainerMobile>
      );
    } else {
      return (
        <S.Container>
          <HorizontalSlide
            slideData={slideData}
            // isAutoNext={true}
            timeNext={4000}
          />
        </S.Container>
      );
    }
  }, [isMobile, t]);

  return (
    <S.WrapperContainer id="business">
      {renderSlider}
      <img
        src={SlideDown}
        alt="Down"
        className="icon-down-slider"
        id="icon-down-slider"
        onClick={(e) => ScrollToCenter(e)}
      />
    </S.WrapperContainer>
  );
}

export default Slider;
